import { ITool } from 'models/tool';
import { get } from '.';
 
export const getPublicTools = () => get<ITool[]>('/public/tools', true); 